export type PMSReportType = 'PM-performance-report' | 'OPS-treasury-report' | 'OPS-IBOR-ABOR';

export const PMS_REPORT_TYPES = [
  'PM-performance-report',
  'OPS-treasury-report',
  'OPS-IBOR-ABOR',
] as const satisfies readonly PMSReportType[];

/** Display titles for report types (breadcrumbs, report configs, etc.) */
export const PMS_REPORT_TYPE_TITLES = {
  'PM-performance-report': 'Historical Performance',
  'OPS-treasury-report': 'Historical Balance',
  'OPS-IBOR-ABOR': 'IBOR x ABOR Reconciliation',
} as const satisfies Record<PMSReportType, string>;
